var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlant = function SvgPlant(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 12.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.246 11.535a4.3 4.3 0 0 0 2.892-2.75 4.3 4.3 0 0 0-3.877-.942A4.31 4.31 0 0 0 7.37 10.6a4.31 4.31 0 0 0 3.877.935M3.492 11.535A4.3 4.3 0 0 1 .6 8.785a4.31 4.31 0 0 1 3.877-.942A4.31 4.31 0 0 1 7.369 10.6a4.31 4.31 0 0 1-3.877.935M7.37.6s2.46 1.415 2.46 3.385c0 1.36-1.1 2.154-2.46 2.154s-2.462-.794-2.462-2.154C4.908 2.015 7.369.6 7.369.6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlant);
export default ForwardRef;